(() => {
  const resolveUrl = (rawUrl, origin = globalThis.location?.origin || '') => {
    if (!rawUrl || !origin) return '';
    try {
      const url = new URL(rawUrl, origin);
      if (url.origin !== origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      url.hash = '';
      url.search = '';
      url.searchParams.set('view', 'card');
      return url.toString();
    } catch (_) {
      return '';
    }
  };

  const defaultParseCard = (html) => {
    const documentNode = new DOMParser().parseFromString(html, 'text/html');
    return documentNode.querySelector('[data-fizo-collection-product-card]');
  };

  const fetchCard = async (rawUrl, options = {}) => {
    const origin = options.origin || globalThis.location?.origin || '';
    const url = resolveUrl(rawUrl, origin);
    if (!url) return null;
    const fetcher = options.fetcher || globalThis.fetch;
    const parseCard = options.parseCard || defaultParseCard;
    if (typeof fetcher !== 'function') return null;
    try {
      const response = await fetcher(url, {credentials: 'same-origin', headers: {Accept: 'text/html'}});
      if (!response.ok) return null;
      return parseCard(await response.text()) || null;
    } catch (_) {
      return null;
    }
  };

  const fetchCards = async (rawUrls, options = {}) => {
    const cards = await Promise.all((Array.isArray(rawUrls) ? rawUrls : []).map((url) => fetchCard(url, options)));
    return cards.filter(Boolean);
  };

  globalThis.FizoProductCardFragment = Object.freeze({resolveUrl, fetchCard, fetchCards});
})();
